<template>
  <v-dialog
    v-model="announcementDialog"
    max-width="500"
    persistent
    v-if="announcement"
  >
    <v-card>
      <v-card-title>系統公告</v-card-title>
      <v-card-text class="text-h6">{{ announcement.content }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="checkAnnouncement"> 瞭解 </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Announcement",
  props: ["type"],
  data: () => ({
    announcementDialog: false,
    announcement: {
      enable: false,
      content: null,
    },
  }),
  async created() {
    await this.loadConfigs();
    if (
      this.announcement &&
      this.announcement.content != this.$store.state[this.type].content &&
      this.announcement.enable
    ) {
      this.announcementDialog = true;
    }
  },
  methods: {
    async loadConfigs() {
      if (this.type == "announcement") {
        this.announcement = (
          await this.axios.get("/public/announcement")
        ).data;
        return;
      }

      let configs = (await this.axios.get("/dashboard/configs")).data;
      this.announcement = configs[this.type];
    },
    checkAnnouncement() {
      let payload = {};
      payload[this.type] = this.announcement;

      this.$store.commit("setState", payload);
      this.announcementDialog = false;
    },
  },
};
</script>

<style></style>
